<template>
  <div class="form">
    <div class="container">
      <div class="rowView pageFirstView contactForm">
        <div class="areaPageTitle">
          <h1>Contact</h1>
        </div>
<!--
        <p class="">
各サービスに関するご質問は下記フォーム、<a @mouseenter="setTarget('mail')" @mouseleave="setTarget('')">メール</a>・<a @mouseenter="setTarget('tel')" @mouseleave="setTarget('')">お電話</a>にてお気軽にお問い合せください。
        </p>
-->
        <p class="">
各サービスに関するご質問は下記フォーム、メール、お電話にてお気軽にお問い合せください。
        </p>
      </div>
    </div>
    <section class="tagJumpTarget" id="FormArea">
        <div class="phasePosition" id="ContactTop">
          <svg class="indicatorSVG">
            <use class="" xlink:href="#Indicator"></use>
          </svg>
          <ul>
            <li>入力</li>
            <li>確認</li>
            <li>送信</li>
          </ul>
        </div>
      <Indicator ref="phaseView" v-bind={currentPhase}></Indicator> 
      <component :is="currentPhase" v-bind={fields:inputData} v-on:changePhase="setPhase"></component>
    </section>

  </div>
</template>

<script>
/*
フォーム機能：バリデーションチェック、confirm画面、状態遷移表示がある機能を実装する
routerで制御せずに、親子関係で
*/
import FormInput from '@/views/form/FormInput.vue'
import FormConfirm from '@/views/form/FormConfirm.vue'
import FormThanks from '@/views/form/FormThanks.vue'
import PhaseIndicator from '@/views/form/PhaseIndicator.vue'

var currentPhase = 'form-input'
var fields = {
  name:'', 
  company:'',
  department:'',
  mail:'',
  telephone:'',
  inquirys:[],
  freeText:''
}
var sideButtonTarget = ''

export default {
  name: 'contact',
  components:{
    'form-input':FormInput,
    'form-confirm':FormConfirm,
    'form-thanks':FormThanks,
    'Indicator':PhaseIndicator,
  },
  data() {
    return {
      currentPhase,
      inputData:fields,
      sideButtonTarget,
			pageTitle:"お問い合わせフォーム",
			description:"お見積り、採用、制作に関するご質問など、このフォームをご利用ください",
			keywords:"お問い合わせ フォーム お見積り 採用 制作",
			ogType:"article",
    }
  },
  mounted: function() {console.log("mounted "+this.$options.name)

    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', this.isUrl)
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
  updated:function() {console.log("updated "+this.$options.name)
    document.getElementById("ContactTop").scrollIntoView({behavior:"smooth"})

    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', this.isUrl)
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
  methods:{
    setPhase: function(phase) {
      this.currentPhase = phase
    },
/*サイドボタンをリンクのマウスオーバで開きたいときは以下を使用する*/
/*
    setTarget: function(target) {
      this.$emit('sideButton', target)
    },
*/
  },
}

</script>

<style>
</style>